import { useTranslation } from 'react-i18next';

export function useMainCardController() {
  const { t } = useTranslation();

  const mainTitleText = t('charity.main.title');

  return { mainTitleText };
}
